import { supabase } from './supabase';

export const storageService = {
  async uploadBeat(file: File): Promise<string> {
    // Get the current user
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user) {
      throw new Error('User not authenticated for file upload.');
    }
    const userId = session.user.id;

    const fileExt = file.name.split('.').pop();
    const fileName = `${Math.random().toString(36).substring(2)}.${fileExt}`;
    // Correctly place the file in a folder named after the user's ID
    const filePath = `${userId}/${fileName}`;

    const { error: uploadError } = await supabase.storage
      .from('beats')
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: false,
      });

    if (uploadError) {
      console.error('Error uploading file:', uploadError);
      throw uploadError;
    }

    // Get public URL
    const { data: { publicUrl } } = supabase.storage
      .from('beats')
      .getPublicUrl(filePath);

    return publicUrl;
  },

  async uploadVerse(file: File): Promise<string> {
    // Get the current user
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user) {
      throw new Error('User not authenticated for file upload.');
    }
    const userId = session.user.id;

    const fileExt = file.name.split('.').pop();
    const fileName = `${Math.random().toString(36).substring(2)}.${fileExt}`;
    // Correctly place the file in a folder named after the user's ID
    const filePath = `${userId}/${fileName}`;

    const { error: uploadError } = await supabase.storage
      .from('verses')
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: false,
      });

    if (uploadError) {
      console.error('Error uploading file:', uploadError);
      throw uploadError;
    }

    // Get public URL
    const { data: { publicUrl } } = supabase.storage
      .from('verses')
      .getPublicUrl(filePath);

    return publicUrl;
  },

  async deleteBeat(filePath: string): Promise<void> {
    const { error } = await supabase.storage
      .from('beats')
      .remove([filePath]);

    if (error) {
      console.error('Error deleting file:', error);
      throw error;
    }
  },

  async deleteVerse(filePath: string): Promise<void> {
    const { error } = await supabase.storage
      .from('verses')
      .remove([filePath]);

    if (error) {
      console.error('Error deleting file:', error);
      throw error;
    }
  },

  getPublicUrl(bucket: string, filePath: string): string {
    return supabase.storage.from(bucket).getPublicUrl(filePath).data.publicUrl;
  },

  /**
   * Convert a stored file reference (full public URL or already-relative
   * path) into the bucket-relative path that storage operations expect.
   * Returns null when the URL doesn't belong to the given bucket.
   */
  getStoragePathFromUrl(fileUrl: string, bucket: string): string | null {
    if (!fileUrl) return null;
    if (!fileUrl.startsWith('http')) {
      return fileUrl; // already a bucket-relative path
    }
    const marker = `/storage/v1/object/public/${bucket}/`;
    const idx = fileUrl.indexOf(marker);
    if (idx === -1) return null;
    const raw = fileUrl.substring(idx + marker.length).split('?')[0];
    try {
      return decodeURIComponent(raw);
    } catch {
      return raw;
    }
  }
}; 